const imageSources = {
  en: {
    welcomeImage: "./welcomeballoon.png",
    infoPanelOne: "./tninfopaneloneen.png",
    buttonsLine: "./tnbuttonslinesen.png",
    guideExample: "./tnguideexpen.png",
    guideExampleTwo: "./tnguideexptwoen.png",
    regularUpload: "./tnregularuploaden.png",
    activateImage: "./tnactivateimgen.png",
  },
  es: {
    welcomeImage: "./welcomeballoon.png",
    infoPanelOne: "./tninfopanelone.png",
    buttonsLine: "./tnbuttonslines.png",
    guideExample: "./tnguideexp.png",
    guideExampleTwo: "./tnguideexptwo.png",
    regularUpload: "./tnregularupload.png",
    activateImage: "./tnactivateimg.png",
  },
  pt: {
    welcomeImage: "./welcomeballoon.png",
    infoPanelOne: "./tninfopanelonept.png",
    buttonsLine: "./tnbuttonslinespt.png",
    guideExample: "./tnguideexppt.png",
    guideExampleTwo: "./tnguideexptwopt.png",
    regularUpload: "./tnregularuploadpt.png",
    activateImage: "./tnactivateimgpt.png",
  },
};

export default imageSources;
